var map = {
	"./ADDITIONAL_ACTIVITY.webp": "5328",
	"./COMITE_MEETING.webp": "38f2",
	"./GAME.webp": "b21c",
	"./PHYSICAL_TRAINING.webp": "4b74",
	"./THEORIC_TRAINING.webp": "3a12",
	"./torneo_otono/rumberos_en_espana.webp": "1094"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b0a1";